/* eslint-disable @typescript-eslint/naming-convention */
'use server';
import { Locale } from '../../Entities/Locale/Locale.entity';

export async function saveSearchAction(
  email: string,
  searchQuery: string,
  plpUrl: string,
  locale: Locale,
) {
  try {
    const response = await fetch(`${process.env.COMMON_API_URL}/i15/saved-searches`, {
      method: 'POST',
      body: JSON.stringify({ email, searchQuery, plpUrl }),
      headers: {
        Accept: 'application/json',
        'content-type': 'application/json',
        'x-heycar-tenant': locale,
      },
    });
    return {
      text: response.statusText,
      error: response.status !== 201,
    };
  } catch (error: any) {
    console.error(error);
    return {
      text: error,
      error: true,
    };
  }
}

export async function deleteSaveSearch(
  savedSearchId: string,
  encryptedEmail: string,
  locale: Locale,
) {
  try {
    const response = await fetch(
      `${process.env.COMMON_API_URL}/i15/saved-searches/${savedSearchId}`,
      {
        method: 'DELETE',
        body: JSON.stringify({ encryptedEmail }),
        headers: {
          Accept: 'application/json',
          'content-type': 'application/json',
          'x-heycar-tenant': locale,
        },
      },
    );

    return {
      text: response.statusText,
      error: response.status !== 204,
    };
  } catch (error: any) {
    console.error(error);
    return {
      text: error,
      error: true,
    };
  }
}

export async function confirmEmailAction(encryptedEmail: string, locale: Locale) {
  try {
    const response = await fetch(`${process.env.COMMON_API_URL}/i15/search-user-profile/confirm`, {
      method: 'POST',
      body: JSON.stringify({ encryptedEmail }),
      headers: {
        Accept: 'application/json',
        'content-type': 'application/json',
        'x-heycar-tenant': locale,
      },
    });

    return {
      text: response.statusText,
      error: response.status !== 204,
    };
  } catch (error: any) {
    console.error(error);
    return {
      text: error,
      error: true,
    };
  }
}
